export const styles = theme => ({
  photoZoom: {
    position: 'relative',
    zIndex: 10,
    height: '300px',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      height: 150,
    },
  },

  photo: {
    width: '100%',
    objectFit: 'cover',
    height: '100%',
    cursor: 'pointer',
    transition: 'transform 0.5s ease',
    '&:hover': {
      transform: 'scale(1.15)',
    },
  },
})
